import React from 'react';
import ServiceCard from './ServiceCard';
import { motion } from 'framer-motion';
import { SERVICES_DATA } from '../constants';

const Services = () => {
    const services = SERVICES_DATA;

    return (
        <section id="services" className="relative py-4 sm:py-8 px-4 sm:px-6 lg:px-8 bg-white overflow-visible">
            <div className="max-w-7xl mx-auto relative z-10 bg-gray-50 rounded-[1.5rem] sm:rounded-[20px] py-16 sm:py-24 px-6 sm:px-12 lg:px-16 shadow-2xl">
                {/* Background Decorations Inside Container */}
                <div className="absolute inset-0 w-full h-full overflow-hidden pointer-events-none rounded-[20px]">
                    <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-white/5 rounded-full blur-[120px]" />
                    <div className="absolute bottom-[-10%] left-[-10%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px]" />
                </div>

                {/* Header Section */}
                <div className="text-center max-w-3xl mx-auto mb-20 relative z-10">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        className="inline-block px-4 py-1.5 mb-6 rounded-full bg-black shadow-sm"
                    >
                        <span className="text-white text-sm font-black uppercase tracking-widest">Our Services</span>
                    </motion.div>

                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                        className="text-3xl sm:text-4xl md:text-5xl font-bold text-primary mb-4 sm:mb-6 leading-tight"
                    >
                        New Listings & Services
                    </motion.h2>

                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        className="text-primary/80 text-base sm:text-lg md:text-xl leading-relaxed font-medium"
                    >
                        Explore our comprehensive services tailored for your needs. We provide end-to-end solutions for society redevelopment.
                    </motion.p>
                </div>

                {/* Services Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 items-stretch relative z-10">

                    {/* Left Column - 2 Cards */}
                    <div className="flex flex-col gap-10 h-full">
                        <motion.div
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6 }}
                            className="h-full"
                        >
                            <ServiceCard {...services[0]} />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6, delay: 0.1 }}
                            className="h-full"
                        >
                            <ServiceCard {...services[1]} />
                        </motion.div>
                    </div>

                    {/* Middle Column - Large Feature/Image */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="relative min-h-[350px] sm:min-h-[400px] lg:min-h-full rounded-[1.5rem] sm:rounded-3xl overflow-hidden group shadow-2xl border-4 border-white"
                    >
                        <img
                            src="/services-featured.png"
                            alt="Excalibur Projects Featured Urban Architecture Mumbai"
                            loading="lazy"
                            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-primary/80 via-transparent to-transparent opacity-60" />

                        <div className="absolute bottom-6 sm:bottom-8 left-6 sm:left-8 right-6 sm:right-8 text-white">
                            <div className="bg-black text-white px-4 py-1 rounded-full text-[10px] sm:text-xs font-bold uppercase inline-block mb-2 sm:mb-3">Featured</div>
                            <h3 className="text-xl sm:text-2xl font-bold mb-1 sm:mb-2 leading-tight">Excellence in Every Detail</h3>
                            <p className="text-white/80 text-[11px] sm:text-sm leading-tight font-medium">Providing bespoke solutions for modern urban redevelopment projects across the globe.</p>
                        </div>
                    </motion.div>

                    {/* Right Column - 2 Cards */}
                    <div className="flex flex-col gap-10 h-full">
                        <motion.div
                            initial={{ opacity: 0, x: 30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                            className="h-full"
                        >
                            <ServiceCard {...services[2]} />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, x: 30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                            className="h-full"
                        >
                            <ServiceCard {...services[3]} />
                        </motion.div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Services;

